import { Button } from '$components'
import { useCreateAppointmentForm } from '.'

export function CreateAppointmentFormControls() {
  const { onCancel, isLoading } = useCreateAppointmentForm()

  return (
    <div className="flex gap-stack-roomy mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        type="submit"
        size="lg"
        isLoading={isLoading}
      >
        Schedule Appointment
      </Button>
    </div>
  )
}
